export class GoPdfLoader {
	private pdfCache = {};

	public async getPdfJs () {
		return await import(/* webpackChunkName: "pdfjs" */ './go-pdf-worker-loader');
	}

	public async load (url: string): Promise<any> {
		const cacheKey = url.split('?')[0];
		const pdfjs = await this.getPdfJs();

		return new Promise((resolve, reject) => {
			if (this.pdfCache[cacheKey]) {
				return resolve(this.pdfCache[cacheKey]);
			}

			const loadingTask = pdfjs.getDocument(url);
			loadingTask.promise.then((pdf) => {
				this.pdfCache[cacheKey] = pdf;
				return resolve(pdf);
			}, (error) => {
				reject(new Error('GoPDFLoader::Failed to load ' + error));
			});
		});
	}
}
